export default {
  promiseTimeout(ms: number) {
    return new Promise<void>(function (resolve) {
      let t = setTimeout(function () {
        resolve();
        clearTimeout(t);
      }, ms);
    });
  },
  avg(values: number[]) {
    return values.length > 0
      ? values.reduce((v, prev) => v + prev, 0) / values.length
      : 0;
  },
  /**
   * @param {[number]} values
   * @returns {number|*}
   */
  median(values: number[]) {
    if (values.length === 0) return 0;

    values.sort(function (a, b) {
      return a - b;
    });

    let half = Math.floor(values.length / 2);

    if (values.length % 2) return values[half];

    return (values[half - 1] + values[half]) / 2.0;
  },
  /**
   * @param {[{x:number,y:number}]} data
   * @param stackDivider in milliseconds
   * @param mutateDivider in milliseconds
   * @returns {[]}
   */
  interpolate(
    data: { x: number; y: number }[],
    stackDivider = 30,
    mutateDivider = 60
  ) {
    if (!data) return [];
    let group: { [key: number]: number[] } = {};
    for (let row of data) {
      let ts: number = Math.floor(row.x / stackDivider);
      if (group[ts] === undefined) group[ts] = [];
      group[ts].push(row.y);
    }

    let result: { x: number; y: number }[] = [];
    for (let ts in group) {
      // @ts-ignore
      let x = (ts * stackDivider) / mutateDivider;
      let y = this.median(group[ts]);
      result.push({
        x,
        y: parseFloat(y.toFixed(2)),
      });
    }

    return result;
  },
};
